import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

const TABS = [
  { id: 'shop', icon: '🏪', i18nKey: 'nav.shop', route: '/' },
  { id: 'upgrade', icon: '⬆️', i18nKey: 'nav.upgrade', route: '/upgrade' },
  { id: 'quest', icon: '📋', i18nKey: 'nav.quest', route: '/quest' },
  { id: 'stats', icon: '📊', i18nKey: 'nav.stats', route: '/stats' },
] as const;

export function BottomNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="h-[56px] bg-cream-50 border-t border-coffee-700/10 game-ui safe-area-bottom">
      <div className="h-[56px] grid grid-cols-4">
        {TABS.map((tab) => {
          const isActive = location.pathname === tab.route;
          return (
            <button
              key={tab.id}
              onClick={() => navigate(tab.route)}
              className="flex flex-col items-center justify-center gap-0.5 relative active:scale-95 transition"
            >
              {isActive && (
                <div className="absolute top-1 w-1 h-1 rounded-full bg-yellow-light" />
              )}
              <span className={`text-lg ${!isActive && 'opacity-50'}`}>{tab.icon}</span>
              <span
                className={`text-[10px] font-medium ${
                  isActive ? 'text-coffee-900' : 'text-coffee-700/60'
                }`}
              >
                {t(tab.i18nKey)}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
